import { useLazyQuery, useSubscription } from '@apollo/client/react'
import { toast } from 'react-toastify'
import {
  GetTableReportDocument,
  GetTableShiftDocument,
  SubscriptionReportGenerateDocument,
  SubscriptionReportGenerateSubscription,
} from 'src/apollo/generated/graphql'

export const useSubscriptionCompletedReportGeneration = () => {
  const [fetchTableReport] = useLazyQuery(GetTableReportDocument, {
    fetchPolicy: 'network-only',
  })

  const [fetchTableCompletedShift] = useLazyQuery(GetTableShiftDocument, {
    fetchPolicy: 'network-only',
  })

  const onUpdateData = async (data?: SubscriptionReportGenerateSubscription) => {
    if (!data?.reportGenerated) return

    const id = data.reportGenerated.id

    await fetchTableReport({ variables: { input: { id } } })

    if (data?.reportGenerated?.shiftId) {
      await fetchTableCompletedShift({
        variables: { getShiftInput2: { id: data.reportGenerated.shiftId } },
      })
    }

    toast.success('Report ready for download', {
      autoClose: false,
      closeOnClick: true,
    })
  }

  useSubscription(SubscriptionReportGenerateDocument, {
    onData: ({ data: { data } }) => {
      onUpdateData(data)
    },
  })

  return {}
}
